export function createPageContextRegistry() {
    const entries = []

    function registerPageContext(context) {
        if (!context || typeof context !== 'object') {
            throw new TypeError('PageContext inválido.')
        }
        const token = Symbol('page-context')
        entries.push({ token, context })
        return () => {
            const index = entries.findIndex((entry) => entry.token === token)
            if (index >= 0) entries.splice(index, 1)
        }
    }

    function currentPageContext() {
        return entries.at(-1)?.context || null
    }

    function clear() {
        entries.splice(0)
    }

    return {
        registerPageContext,
        currentPageContext,
        clear,
        size: () => entries.length,
    }
}
